import { render, staticRenderFns } from "./Crisp.vue?vue&type=template&id=2fb88b24&"
import script from "./Crisp.vue?vue&type=script&lang=js&"
export * from "./Crisp.vue?vue&type=script&lang=js&"
import style0 from "./Crisp.vue?vue&type=style&index=0&id=2fb88b24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports